// Deprecated
import { SalesOrderSource } from '@erp/shared-types';

export enum SalesOrderStatus {
  pending = 'pending',
  in_progress = 'in_progress',
  fulfilled = 'fulfilled',
  closed = 'closed',
}

export enum SalesOrderSyncStatus {
  not_started = 'not_started', // sales order created, but not queued
  pending = 'pending', // queued for sync
  in_progress = 'in_progress', // sync in progress
  success = 'success', // sync succeeded
  failed = 'failed', // sync failed
}

export interface Notes {
  type: string;
  content: string;
  createdAt: Date;
  createdBy: string;
}

export enum SalesOrderItemType {
  customer_purchase_order_line_item = 'customer_purchase_order_line_item',
  direct_entry = 'direct_entry',
}

export interface SalesOrderDTO {
  id: string;
  internalId: number;
  organizationId: string;
  customerId: string;
  customerPurchaseOrderId?: string | null;
  source: SalesOrderSource;
  inboundEmailId?: string | null;
  creatorId?: string | null;
  orderDate: Date;
  deliveryDate?: Date | null;
  shipDate?: Date | null;
  status: SalesOrderStatus;
  totalAmount: number;
  notes?: Notes[] | null;
  salesOrderLineItems: Array<{
    id: string;
    salesOrderId: string;
    salesOrderItemType: SalesOrderItemType;
    productId?: string | null;
    productVariantId?: string | null;
    customerPurchaseOrderLineItemId?: string | null;
    customerPurchaseOrderLineItem?: {
      id: string;
      organizationId: string;
      customerPurchaseOrderId: string;
      customerProductId: string;
      quantity: number;
      unitPrice: number;
      totalPrice: number;
      customerProduct?: {
        id: string;
        name: string;
        sku: string;
        organizationId: string;
        productId: string;
        unitVariationId: string;
        product?: {
          id: string;
          sku?: string | null;
          name: string;
          description?: string | null;
          categoryId?: string | null;
          hasVariations: boolean;
          baseVariationId?: string | null;
          metadata?: object | null;
        };
        unitVariation?: {
          id: string;
          organizationId: string;
          productId: string;
          name: string;
          sku: string;
          quantityInBaseUnit: number;
          unitOfMeasure?: string | null;
          unitCost?: number | null;
          pricePerUnit?: number | null;
          isSellable: boolean;
          hasBillOfMaterials: boolean;
          metadata?: object | null;
          activeBillOfMaterialsId?: string | null;
          inventoryItems: Array<{
            id: string;
            currentStockLevel: number;
            reservedStockLevel: number;
            minimumStockLevel: number;
            maximumStockLevel?: number | null;
            reorderPoint: number;
            warehouseId?: string | null;
            warehouseSectionId?: string | null;
          }>;
          inventoryLevels: {
            total: {
              current: number;
              reserved: number;
              minimum: number;
              maximum?: number | null;
              reorderPoint: number;
            };
            byWarehouse: Array<{
              warehouseId: string | null;
              warehouseSectionId: string | null;
              current: number;
              reserved: number;
              minimum: number;
              maximum?: number | null;
              reorderPoint: number;
            }>;
          };
        };
      };
    };
    quantity?: number | null;
    unitPrice?: number | null;
    lineTotal: number;
  }>;
  customer?: {
    name: string;
    erpDisplayName?: string | null;
    address?: string | null;
    phoneNumber?: string | null;
    emailDomain?: string | null;
    contactPerson?: string | null;
    paymentTerms?: string | null;
    creditLimit?: number | null;
  };
  customerPurchaseOrder?: {
    internalId: number;
    organizationId: string;
    customerId: string;
    userId: string;
    stagedCustomerPurchaseOrderId: string;
    purchaseOrderNumber: string;
    orderDate: Date;
    status: string;
    totalAmount: number;
  } | null;
  originId?: string;
  originSystem?: string;
  originEntity?: string;
  originSyncStatus?: SalesOrderSyncStatus | null;
  originSyncErrorMessage?: string | null;
  createdAt: Date;
  updatedAt: Date;
}
